import { Injectable } from '@angular/core';
import { PAYMASH_PROFILE } from '@profile';
import moment from 'moment';
import { File } from '@paymash/capacitor-filesystem-plugin';
import { unpack } from '@core/services/utils/buffer.utils';
import { PutObjectOutput } from 'aws-sdk/clients/s3';
import { AWSError } from 'aws-sdk';


@Injectable()
export class AwsService {
  private awsOptions = unpack(PAYMASH_PROFILE.ASW as string);

  public async sendData(pathOnAws: string, fileName: string, data: Blob): Promise<any> {
    const S3 = await import('aws-sdk/clients/s3').then((m) => m.default);
    const bucket = new S3({
      ...(this.awsOptions.a || {}),
      correctClockSkew: true,
    });
    return new Promise((resolve, reject) => {
      const request = bucket.putObject({
        ...(this.awsOptions.b || {}),
        Body: data,
        Key: `pos/${pathOnAws}${fileName}`,
      });
      request.on('httpError', (err) => reject(err));
      request.send((err: AWSError, data: PutObjectOutput): void => {
        err ? reject(err) : resolve(data);
      });
    });
  }

  public makeAwsLink(companyId: string | number, platform: string, deviceUuid: string, folder: string): string {
    const today = moment().format('YYYY-MM-DD');
    const time = moment().format('HH:mm:ss');
    return `company/${companyId}/pos-system/${today}/${platform}/${deviceUuid}/${folder}/${time}/`;
  }

  public async sendFilesToAws(files: File[], pathOnAws: string, fileName: string): Promise<void> {
    if (!files.length) {
      return;
    }
    const JSZip = await import('jszip').then((m) => m.default);
    const zip = new JSZip();
    for (const file of files) {
      const fileData = await file.readAsString();
      zip.file(file.name, fileData);
    }
    const data = await zip.generateAsync({ type: 'blob', compression: 'DEFLATE' });
    await this.sendData(pathOnAws, fileName, data);
  }

}
